import {
  ref,
  unref,
  inject,
  provide,
  computed,
  onMounted,
  onBeforeUnmount,
  type InjectionKey,
  type Ref,
  type ComputedRef,
} from 'vue';

export { createOverlayLoading, useOverlayLoading };

type OverlayLoadingStore = ReturnType<typeof initializeOverlayLoading>;
const OverlayLoadingKey: InjectionKey<OverlayLoadingStore> = Symbol(
  'OverlayLoadingStore'
);

function initializeOverlayLoading() {
  const watchList: Ref<Record<string, boolean | Ref<boolean>>> = ref({});
  const loading = computed(() =>
    Object.values(watchList.value).some(v => unref(v))
  );
  const addList = (key: string, watchedVal: boolean | Ref<boolean>) => {
    watchList.value[key] = watchedVal;
  };
  const removeList = (key: string) => {
    delete watchList.value[key];
  };

  const store = { loading, addList, removeList };
  provide(OverlayLoadingKey, store);
  return store;
}

function createOverlayLoading(): ComputedRef<boolean>;
function createOverlayLoading(
  key: string,
  watchedVal: boolean | Ref<boolean>
): ComputedRef<boolean>;
function createOverlayLoading(arg1?: string, arg2?: boolean | Ref<boolean>) {
  const { loading, addList, removeList } = initializeOverlayLoading();
  if (arg1) {
    onMounted(() => addList(arg1, arg2 as boolean | Ref<boolean>));
    onBeforeUnmount(() => removeList(arg1));
  }
  return loading;
}

function useOverlayLoading(
  key: string,
  watchedVal: boolean | Ref<boolean>
): void {
  const { addList, removeList } = inject(
    OverlayLoadingKey
  ) as OverlayLoadingStore;

  onMounted(() => addList(key, watchedVal));
  onBeforeUnmount(() => removeList(key));
}
